import { generateRootObjectSchema } from "components/cards/common/schema";
import { BaseAtomSpec, generateAtomContainerSchema } from "components/cards/atoms/BaseAtomSpec";
import { PageParticleSpec } from "components/cards/particles/YinzCam";

export const specification = new BaseAtomSpec("Embedded Page", generateRootObjectSchema({
  container: generateAtomContainerSchema(),
  page: PageParticleSpec.generateSchema("Page", "The embedded page."),
}));
